/**
 * AUTOMATICALLY GENERATED FILE - DO NOT EDIT DIRECTLY
 * Generated from src/foundations/colors.scss
 */

export const ManifestTextColors = {
  colorTextTitle: 'rgba(247, 248, 248, 1)',
  colorTextBase: 'rgba(215, 216, 220, 1)',
  colorTextMuted: 'rgba(139, 143, 152, 1)',
  colorTextFaint: 'rgba(106, 112, 118, 1)',
  colorTextRed: 'rgba(251, 96, 142, 1)',
  colorTextYellow: 'rgba(243, 169, 60, 1)',
  colorTextGreen: 'rgba(78, 185, 105, 1)',
  colorTextOrange: 'rgba(237, 118, 93, 1)',
  colorTextPrimary: 'rgba(30, 188, 226, 1)',
  colorTextWhite: 'rgba(255, 255, 255, 1)',
};

export type ManifestTextColorsKey =
  | 'colorTextTitle'
  | 'colorTextBase'
  | 'colorTextMuted'
  | 'colorTextFaint'
  | 'colorTextRed'
  | 'colorTextYellow'
  | 'colorTextGreen'
  | 'colorTextOrange'
  | 'colorTextPrimary'
  | 'colorTextWhite';

export const ManifestAccentColors = {
  colorBlue1: 'rgba(37, 99, 216, 1)',
  colorOrange1: 'rgba(237, 118, 93, 1)',
  colorYellow1: 'rgba(243, 169, 60, 1)',
  colorGreen1: 'rgba(78, 185, 105, 1)',
  colorRedorange: 'rgba(206, 66, 58, 1)',
  colorPink: 'rgba(232, 137, 171, 1)',
  colorLigthyellow: 'rgba(252, 236, 163, 1)',
  colorDarkgreen: 'rgba(74, 143, 71, 1)',
  colorTeal: 'rgba(22, 63, 89, 1)',
  colorPurple: 'rgba(125, 101, 238, 1)',
  colorViolet: 'rgba(150, 82, 148, 1)',
};

export type ManifestAccentColorsKey =
  | 'colorBlue1'
  | 'colorOrange1'
  | 'colorYellow1'
  | 'colorGreen1'
  | 'colorRedorange'
  | 'colorPink'
  | 'colorLigthyellow'
  | 'colorDarkgreen'
  | 'colorTeal'
  | 'colorPurple'
  | 'colorViolet';

export const ManifestSurfaceColors = {
  colorSurface1: 'rgba(19, 27, 38, 1)',
  colorSurface2: 'rgba(21, 31, 45, 1)',
  colorSurface3: 'rgba(23, 34, 49, 1)',
  colorSurface4: 'rgba(25, 36, 52, 1)',
};

export type ManifestSurfaceColorsKey = 'colorSurface1' | 'colorSurface2' | 'colorSurface3' | 'colorSurface4';

export const ManifestAlertBackgroundColors = {
  colorAlertBackgroundInfo: 'rgba(37, 99, 216, 0.2)',
  colorAlertBackgroundError: 'rgba(204, 54, 99, 0.2)',
  colorAlertBackgroundWarning: 'rgba(243, 169, 60, 0.15)',
  colorAlertBackgroundSuccess: 'rgba(78, 185, 105, 0.15)',
};

export type ManifestAlertBackgroundColorsKey =
  | 'colorAlertBackgroundInfo'
  | 'colorAlertBackgroundError'
  | 'colorAlertBackgroundWarning'
  | 'colorAlertBackgroundSuccess';

export const ManifestColors = {
  colorBlack: 'rgba(11, 16, 23, 1)',
  colorWhite: 'rgba(255, 255, 255, 1)',
  colorPrimary1: 'rgba(30, 188, 226, 1)',
  colorPrimary2: 'rgba(16, 169, 208, 1)',
  colorPrimary3: 'rgba(18, 144, 186, 1)',
  colorRed1: 'rgba(204, 54, 99, 1)',
  colorRed2: 'rgba(188, 50, 90, 1)',
  colorRed3: 'rgba(171, 46, 82, 1)',
  colorBorderCards: 'rgba(33, 41, 54, 1)',
  colorBorderComponents: 'rgba(51, 63, 81, 1)',
  colorTextTitle: 'rgba(247, 248, 248, 1)',
  colorTextBase: 'rgba(215, 216, 220, 1)',
  colorTextMuted: 'rgba(139, 143, 152, 1)',
  colorTextFaint: 'rgba(106, 112, 118, 1)',
  colorTextRed: 'rgba(251, 96, 142, 1)',
  colorTextYellow: 'rgba(243, 169, 60, 1)',
  colorTextGreen: 'rgba(78, 185, 105, 1)',
  colorTextOrange: 'rgba(237, 118, 93, 1)',
  colorTextPrimary: 'rgba(30, 188, 226, 1)',
  colorTextWhite: 'rgba(255, 255, 255, 1)',
  colorBlue1: 'rgba(37, 99, 216, 1)',
  colorOrange1: 'rgba(237, 118, 93, 1)',
  colorYellow1: 'rgba(243, 169, 60, 1)',
  colorGreen1: 'rgba(78, 185, 105, 1)',
  colorRedorange: 'rgba(206, 66, 58, 1)',
  colorPink: 'rgba(232, 137, 171, 1)',
  colorLigthyellow: 'rgba(252, 236, 163, 1)',
  colorDarkgreen: 'rgba(74, 143, 71, 1)',
  colorTeal: 'rgba(22, 63, 89, 1)',
  colorPurple: 'rgba(125, 101, 238, 1)',
  colorViolet: 'rgba(150, 82, 148, 1)',
  colorSurface1: 'rgba(19, 27, 38, 1)',
  colorSurface2: 'rgba(21, 31, 45, 1)',
  colorSurface3: 'rgba(23, 34, 49, 1)',
  colorSurface4: 'rgba(25, 36, 52, 1)',
  colorAlertBackgroundInfo: 'rgba(37, 99, 216, 0.2)',
  colorAlertBackgroundError: 'rgba(204, 54, 99, 0.2)',
  colorAlertBackgroundWarning: 'rgba(243, 169, 60, 0.15)',
  colorAlertBackgroundSuccess: 'rgba(78, 185, 105, 0.15)',
};

export type ManifestColorKey =
  | 'colorBlack'
  | 'colorWhite'
  | 'colorPrimary1'
  | 'colorPrimary2'
  | 'colorPrimary3'
  | 'colorRed1'
  | 'colorRed2'
  | 'colorRed3'
  | 'colorBorderCards'
  | 'colorBorderComponents'
  | 'colorTextTitle'
  | 'colorTextBase'
  | 'colorTextMuted'
  | 'colorTextFaint'
  | 'colorTextRed'
  | 'colorTextYellow'
  | 'colorTextGreen'
  | 'colorTextOrange'
  | 'colorTextPrimary'
  | 'colorTextWhite'
  | 'colorBlue1'
  | 'colorOrange1'
  | 'colorYellow1'
  | 'colorGreen1'
  | 'colorRedorange'
  | 'colorPink'
  | 'colorLigthyellow'
  | 'colorDarkgreen'
  | 'colorTeal'
  | 'colorPurple'
  | 'colorViolet'
  | 'colorSurface1'
  | 'colorSurface2'
  | 'colorSurface3'
  | 'colorSurface4'
  | 'colorAlertBackgroundInfo'
  | 'colorAlertBackgroundError'
  | 'colorAlertBackgroundWarning'
  | 'colorAlertBackgroundSuccess';
